import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/** 
	$A api 接口请求地址封装
	$C config 系统配置项
	$D dateUtil 时间处理类
	$F file 上传，导出文件处理类
	$H http axios 请求封装
	$S service 共通业务处理
*/
import http from './utils/http';
import api from './config/api-config';
import config from './config/config';
import utils from './utils/utils';
import service from './utils/service';
import dateUtil from './utils/dateUtils';
import echarts from 'echarts';
import {
    Message
} from 'element-ui'
Vue.prototype.$echarts = echarts;

Vue.prototype.$A = api;
Vue.prototype.$C = config;
Vue.prototype.$D = dateUtil;
Vue.prototype.$H = http;
Vue.prototype.$U = utils;
Vue.prototype.$S = service;

// import 'lib-flexible';

// 全局css
import './assets/css/common.css';

// 引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import '../theme/index.css'
Vue.use(ElementUI);
// Iview
import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);

// 全局组件注册
import zdTable from './components/table/index.vue';
Vue.component(zdTable.name,zdTable);
// 列表的分页
import zdpagination from './components/table/table-pagination.vue';
Vue.component(zdpagination.name,zdpagination);
// 面包屑
import ZDBreadCrumb from './components/bread-crumb/index.vue';
Vue.component(ZDBreadCrumb.name,ZDBreadCrumb);
// 区域树形选择
import ZDAreaTree from './components/area-tree/index.vue';
Vue.component(ZDAreaTree.name,ZDAreaTree);
// 区域级联选择
import ZDAreaSelect from './components/area-select/index.vue';
Vue.component(ZDAreaSelect.name,ZDAreaSelect);
// 列表页高级查询
import ZDListQuerys from './components/list-querys/index.vue';
Vue.component(ZDListQuerys.name,ZDListQuerys);
//区域插件
import VDistpicker from 'v-distpicker'
Vue.component('v-distpicker', VDistpicker);




// // 列表的新增按钮
// import ZDAddBtn from './components/buttons/add-button.vue';
// Vue.component(ZDAddBtn.name,ZDAddBtn);
// // 列表的编辑按钮
// import ZDEditBtn from './components/buttons/edit-button.vue';
// Vue.component(ZDEditBtn.name,ZDEditBtn);
// // 列表的导出按钮
// import ZDFileTemplateBtn from './components/buttons/file-template-button.vue';
// Vue.component(ZDFileTemplateBtn.name,ZDFileTemplateBtn);
// // 列表的导入按钮
// import ZDFileUploadBtn from './components/buttons/file-upload-button.vue';
// Vue.component(ZDFileUploadBtn.name,ZDFileUploadBtn);
// // 明细的文件上传
// import ZDDetailFileUploadBtn from './components/buttons/detail-file-upload-button.vue';
// Vue.component(ZDDetailFileUploadBtn.name,ZDDetailFileUploadBtn);
// // 详情页 标题
// import ZDDetailTitle from './components/detail/detail-title.vue';
// Vue.component(ZDDetailTitle.name,ZDDetailTitle);

Vue.config.productionTip = false;

// 路由前置操作
router.beforeEach((to, from, next) => {
	if(to.name === 'register') {
		next();
	} else if (to.name !== "login") {
		if (!store.state.token) {
			next('/');
		} else {
			next();
		}
	} else {
		next();
	}
});

new Vue({
	router,
	store,
	render: h => h(App),
	mounted() {
		this.$store.commit('updateMenuList');
		this.$store.commit('setMenuCollapse',false);
	},
}).$mount('#app')
